import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AssignmentTodo } from "./components/AssignmentTodo";

const Assignment = (props) => {
  const assignmentID = useLocation().pathname.split("/")[3];

  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );

  return (
    <AssignmentTodo
      assignmentID={assignmentID}
      saveData={saveData}
      tempPageName={tempPageName}
    />
  );
};

Assignment.auth = { path: "/assignment/assign/:id", role: "super-admin admin" };
export default Assignment;
